import React from "react";

const LABELS = {
    pending: "Pendiente",
    in_progress: "En progreso",
    completed: "Completado",
    not_done: "No realizado",
};

export const StatusPill = ({ status, className = "" }) => {
    const label = LABELS[status] || status;
    return (
        <span className={`pill pill-${status} ${className}`} data-testid={`status-pill-${status}`}>
            <span className="inline-block w-1.5 h-1.5 rounded-full" style={{
                background: status === "completed" ? "#16A34A" : status === "not_done" ? "#FF0000" : status === "in_progress" ? "#FFD62B" : "#9A9A9A",
            }} />
            {label}
        </span>
    );
};

export default StatusPill;
